import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { DataService } from '@app/shared/common/auth/data.service';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppSessionService } from '@shared/common/session/app-session.service';
import { TaskServiceProxy, UpgradeSubscriptionTaskInput } from '@shared/service-proxies/service-proxies';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';

@Component({
  selector: 'vf-upgrade-subscription',
  templateUrl: './upgrade-subscription.component.html',
  styleUrls: ['./upgrade-subscription.component.css']
})
export class UpgradeSubscriptionComponent extends AppComponentBase implements OnInit {
  @ViewChild('upgradeSubscriptionModal') modal: ModalDirective;
  @Output() successEmit: EventEmitter<any> = new EventEmitter<any>();
  renewSub: UpgradeSubscriptionTaskInput;
  licenseUsers = 1;
  saving = false;
  subscription: Subscription;
  constructor(injector: Injector,
    appSession: AppSessionService,
    private dataservice: DataService,
    private _taskService: TaskServiceProxy
  ) {
    super(injector);
  }

  ngOnInit() {
    this.renewSub = new UpgradeSubscriptionTaskInput();
    this.renewSub.subscriptionType = 'Annually (20% Discount)';
    this.renewSub.licenseUsers = this.appSession.tenant.licenseUsers;
    if (this.appSession.tenant) {
      this.licenseUsers = this.appSession.tenant.licenseUsers;
    }
    if (this.dataservice.openUpgradeModal.observers.length === 0) {
      this.subscription = this.dataservice.openUpgradeModal.subscribe(data => {
        this.modal.show();
        this.updateBodyForCenterModalShow();
      });
    }

  }

  show(): void {
    this.modal.show();
    this.updateBodyForCenterModalShow();
  }

  validateMinUsers() {
    if (this.renewSub.licenseUsers <= this.appSession.tenant.licenseUsers) {
      this.renewSub.licenseUsers = this.appSession.tenant.licenseUsers;
    }
  }

  keyPressValidateUsers() {
    setTimeout(() => {
      this.validateMinUsers();
    }, 2000);
  }

  closeUpgradeModal() {
    this.modal.hide();
    this.updateBodyForCenterModalHide();
    this.dataservice.openUpgModal.next();
  }

  save(): void {
    this.saving = true;
    this._taskService.createUpgradeSubscriptionTask(this.renewSub).subscribe((result) => {
      this.saving = false;
      this.renewSub.subscriptionType = 'Annually (20% Discount)';
      this.renewSub.licenseUsers = this.appSession.tenant.licenseUsers;
      this.renewSub.additionalQuestions = '';
      setTimeout(() => {
        this.successEmit.emit();
      }, 500);
      this.modal.hide();
      this.updateBodyForCenterModalHide();
    });
  }
}
